export default __webpack_public_path__ + "static/media/printing_queue_loading.e6372b7a.png";